import { useLocation } from "react-router-dom";
import EventName from "./EventName";
import ImageComponent from "./ImageComponent";
import DownloadTemplateButton from "./DownloadTemplateButton";
import UploadSpreadsheetButton from "./UploadSpreadsheetButton";
import "./attendeeDetails.css";
import { useEvent } from "./EventDetailsContext";

const AttendeeUploadPage = () => {
  const location = useLocation();
  const { type } = location.state || {};
  const { eventDetails } = useEvent();

  console.log("type", type);

  const isAttendee = eventDetails?.myRole === "Attendee";
  if (isAttendee) {
    return (
      <div className="access-restricted">
        <p style={{ fontSize: '25px',color: '#007272' }}>Access Restricted to Event Managers Only</p>
        <p style={{ fontSize: '30px',color: '#007272' }}>Please fill your details in the <strong><span style={{ color: '#000000' }}>"INDIVIDUAL"</span>
        </strong> Tab</p>
      </div>
    );
  } else {
    return (
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="White_Box">
              <div className="row">
                <div className="col-md-12">
                  <div className="attendee-details">
                    <EventName />
                    <ImageComponent />
                    <div className="buttons mt-5">
                      <DownloadTemplateButton downloadtype={type} />
                      <UploadSpreadsheetButton uploadtype={type} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default AttendeeUploadPage;
